export const HOT_KEYS = [
    { hotKey: '18:13', eventName: 'enableLogger' }, // alt + enter
    { hotKey: '91:13', eventName: 'enableLogger' }, // cmd + enter
    { hotKey: '27', eventName: 'hotKey:escape' }
];
